import { render, staticRenderFns } from "./NewFiltersMenu.vue?vue&type=template&id=6009c7f6"
import script from "./NewFiltersMenu.vue?vue&type=script&lang=js"
export * from "./NewFiltersMenu.vue?vue&type=script&lang=js"
import style0 from "./NewFiltersMenu.vue?vue&type=style&index=0&id=6009c7f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports